import { get, post } from '../axios'

// 查询列表
export function portal_user_list_get(map, option) {
  return get(
    `${process.env.VUE_APP_PORTAL}/portal/user/list`,
    map,
    option
  ).then(response => response)
}

// 角色详情查询
export function portal_user_query_role_id_get(map, option) {
  return get(
    `${process.env.VUE_APP_PORTAL}/portal/user/query/role/${map.id}`,
    map,
    option
  ).then(response => response)
}

// 删除
export function portal_user_delete_role_post(map, option) {
  return post(
    `${process.env.VUE_APP_PORTAL}/portal/user/delete/role`,
    map,
    option
  ).then(response => response)
}

// 批量分配
export function portal_user_create_role_post(map, option) {
  return post(
    `${process.env.VUE_APP_PORTAL}/portal/user/create/role`,
    map,
    option
  ).then(response => response)
}

// 部门组织树
export function portal_department_tree_get(map, option) {
  return get(
    `${process.env.VUE_APP_PORTAL}/portal/department/tree`,
    map,
    option
  ).then(response => response)
}

// 更新用户
export function portal_user_update_post(map, option) {
  return post(
    `${process.env.VUE_APP_PORTAL}/portal/user/update`,
    map,
    option
  ).then(response => response)
}

// 模拟登录权限查询
export function portal_user_hasAccess_get(map, option) {
  return get(
    `${process.env.VUE_APP_PORTAL}/portal/user/hasAccess`,
    map,
    option
  ).then(response => response)
}
